import { FeaturedActivityInfoSnippet } from './InfoSnippet';

export const FeaturedActivitySnippets = {
  Info: FeaturedActivityInfoSnippet,
};
